import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';

import MessageUtils from '../../../utils/MessageUtils';
import { SERVER_URL,
        DEFAULT_PAGE_SIZE } from "../../../utils/Constants";

import {
    LOADING,
    LOAD_MARKETING_AUTOMATIONS,
    LOAD_TRIGGER_IMAGES_SUCCESS,
    REORDER_SECTION_ITEMS,
    LOAD_MARKETING_AUTOMATIONS_DISABLED,
    SELECT_MARKETING_AUTOMATION,
    INITIAL_AUDIENCE,
    LOAD_CUSTOMER_AUTOMATION_SEARCH,
    BLOCK_UNBLOCK_CUSTOMER,
    CHECK_ADD_CUSTOMER,
    ADD_CUSTOMER,
    CLEAR_CUSTOMER_TO_ADD
} from "../../types";

export const loadMarketingAutomations = (restaurantId) => {
    return (dispatch, getState) => {

        const url = `${SERVER_URL}/restaurant/${restaurantId}/promotions?automations=true`;
        // const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios().get(url)
            .then(response => loadMarketingAutomationsSuccess(dispatch, response))
            .catch((err) => loadMarketingAutomationsFail(dispatch, err))
    }
};

const loadMarketingAutomationsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_MARKETING_AUTOMATIONS, payload: response.data })
};

const loadMarketingAutomationsFail = (dispatch, err) => {
    dispatch({ type: LOADING, payload: false });

    if (err.response.status === 401) {
        dispatch({ type: LOAD_MARKETING_AUTOMATIONS_DISABLED })
    } else {
        MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:marketingAutomationsActions.loadTriggersFail'))
    }
}

export const setSelectedMarketingAutomation = (automation, callback) => {
    return (dispatch) => {
        dispatch({ type: SELECT_MARKETING_AUTOMATION, payload: automation });
        if (callback) {
            callback();
        }
    }
};

export const uploadTriggerImage = (restaurantId, formData, callback) => {
    return (dispatch, getState) => {
        
        const newFormData = new FormData();
        newFormData.append('file', formData);

        const url = `restaurant/${restaurantId}/upload-automation-image`;

        axios().put(url, newFormData)
            .then(response => uploadTriggerImageSuccess(dispatch, response, callback))
            .catch(error => MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:marketingAutomationsActions.uploadImageFailure')));
    }
}

const uploadTriggerImageSuccess = (dispatch, response, callback) => {

    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:marketingAutomationsActions.uploadImageSuccess'));

    if(callback) {
        callback()
    }
    
}

export const loadListTriggerImages = (restaurantId) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });
        const url = `restaurant/${restaurantId}/automation-images`;

        axios().get(url)
            .then(response => loadListTriggerImagesSuccess(dispatch, response))
            .catch(error => MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:marketingAutomationsActions.loadImagesFailure')));
    }
}

const loadListTriggerImagesSuccess = (dispatch, response) => {

    dispatch({ type: LOAD_TRIGGER_IMAGES_SUCCESS, payload: response.data });
    dispatch({ type: LOADING, payload: false });

}

export const deleteTriggerImage = (id, callback) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });
        const url = `trigger-image/${id}`;

        axios().delete(url)
            .then(response => deleteTriggerImageSuccess(dispatch, response, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:marketingAutomationsActions.deleteImageFailure')));
    }
}

const deleteTriggerImageSuccess = (dispatch, response, callback) => {

    dispatch({ type: LOADING, payload: false });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:marketingAutomationsActions.deleteImageSuccess'))

    if(callback) {
        callback()
    }
}

export const reorderUpsellProducts = (oldIndex, newIndex) => {
    return (dispatch, getState) => {

        dispatch({type: REORDER_SECTION_ITEMS, payload: {oldIndex, newIndex}});

    }
};
export const loadInitialAudienceCount = (restaurantId, filters) => {
    return (dispatch, getState) => {

        const url = `${SERVER_URL}/restaurant/${restaurantId}/initial-audience`;

        dispatch({ type: LOADING, payload: true });

        axios().post(url, filters)
            .then(response => loadInitialAudienceSuccess(dispatch, response))
            .catch((err) => loadInitialAudienceFail(dispatch, err))
    }
};

const loadInitialAudienceSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: INITIAL_AUDIENCE, payload: response.data })
};

const loadInitialAudienceFail = (dispatch, err) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:marketingAutomationsActions.loadInitialAudienceFail'))
}

export const loadCustomerAutomationSearch = (marketingAutomationId, pageNumber, brandId, searchQuery) => {
    return (dispatch, getState) => {
        
        
        let updatedSearchQuery = { ...searchQuery };
        const finalSearchQuery = getQueryParams(marketingAutomationId, pageNumber, brandId, updatedSearchQuery);
        const url = `${SERVER_URL}/promotion/customer-automation-search?${finalSearchQuery}`;

        dispatch({ type: LOADING, payload: true });

        axios().get(url)
            .then(response => loadCustomerAutomationSearchSuccess(dispatch, response))
            .catch((err) => loadCustomerAutomationSearchFail(dispatch, err))
    }
};

const loadCustomerAutomationSearchSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CUSTOMER_AUTOMATION_SEARCH, payload: response.data })
};

const loadCustomerAutomationSearchFail = (dispatch, err) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:marketingAutomationsActions.loadCustomerAutomationSearch'))
}

export const blockUnblockCustomer = (customerId, willBlock) => {
    return (dispatch, getState) => {
    
        const url = `${SERVER_URL}/promotion/${customerId}/block?block=${willBlock}`;

        dispatch({ type: LOADING, payload: true });

    axios().put(url, {})
            .then(response => blockUnblockCustomerSuccess(dispatch, response))
            .catch((err) => blockUnblockCustomerFail(dispatch, err))
    }
}

const blockUnblockCustomerSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: BLOCK_UNBLOCK_CUSTOMER, payload: response.data })
};

const blockUnblockCustomerFail = (dispatch, err) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:marketingAutomationsActions.blockUnblockCustomer'))
}

export const checkAddCustomer = (marketingAutomationId, customerPhone) => {
    return (dispatch, getState) => {

        if (customerPhone && (customerPhone.includes("+") || customerPhone[0] === '0' )) {
            customerPhone = customerPhone.replace(customerPhone[0], '%2B');
        } else if (customerPhone && !customerPhone.includes("+")) {
            customerPhone = '%2B' + customerPhone;
        }

        const url = `${SERVER_URL}/promotion/${marketingAutomationId}/check-add-customer?phone=${customerPhone}`;

        dispatch({ type: LOADING, payload: true });

        axios().get(url)
                .then(response => checkAddCustomerSuccess(dispatch, response))
                .catch((err) => checkAddCustomerFail(dispatch, err))
    }
}

const checkAddCustomerSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: CHECK_ADD_CUSTOMER, payload: response.data })
};

const checkAddCustomerFail = (dispatch, err) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:marketingAutomationsActions.checkAddCustomer'))
}

export const addCustomer = (marketingAutomationId, customerId, callback) => {
    return (dispatch, getState) => {
        
        const url = `${SERVER_URL}/promotion/${marketingAutomationId}/manual-add-customer?customerId=${customerId}`;
        const customerToAdd = getState().marketingAutomations.customerToAdd;

        dispatch({ type: LOADING, payload: true });

        axios().post(url, {})
            .then(response => addCustomerSuccess(dispatch, customerToAdd, callback))
            .catch((err) => addCustomerFail(dispatch, err))
    }
}

const addCustomerSuccess = (dispatch, customerToAdd, callback) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: ADD_CUSTOMER, payload: customerToAdd })

    if(callback) {
        callback()
    }
};

const addCustomerFail = (dispatch, err) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:marketingAutomationsActions.addCustomer'))
}

export const clearCustomerToAdd = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_CUSTOMER_TO_ADD, payload: undefined });
    } 
}

const getQueryParams = (marketingAutomationId, pageNumber, brandId, searchQuery) => {

    const {
            name,
            email,
            formattedPhone,
            blocked
    } = searchQuery;

    let nameParam = '',
        emailParam = '',
        formattedPhoneParam = '',
        blockedParam = ''
    const pageParam = `page=${pageNumber}`;
    const sizeParam = `&size=${DEFAULT_PAGE_SIZE}`;
    const maIdParam = `&maId=${marketingAutomationId}`;
    const brandIdParam = `&brandId=${brandId}`;

    if (name) {
        nameParam = `&customerName=${name}`
    }

    if (email) {
        emailParam = `&customerEmail=${email}`
    }

    if (formattedPhone) {
        formattedPhoneParam = `&customerPhone=${formattedPhone}`
    }

    if (blocked) {
        blockedParam = `&blocked=${blocked}`
    }

    return `${pageParam}${sizeParam}${maIdParam}${nameParam}${emailParam}${formattedPhoneParam}${blockedParam}${brandIdParam}`;
}

export const saveMarketingAutomation = (restaurantId, state, callback) => {
    return (dispatch, getState) => {

        const priceDiscount = state.discountType === 'PRICE_DISCOUNT' ? { discountValue: state.priceDiscount.discountAmount, valueInPercentage: state.priceDiscount.discountInPercentage } : null;
        const freeProduct = state.discountType === 'FREE_PRODUCT' ? { productId: state.freeProduct.productId, quantity: state.freeProduct.quantity } : null;
        const comboDeal = state.discountType === 'COMBO_DEAL' ? { discountValue: state.comboDeal.discountValue, buyProductsCount: state.comboDeal.buyProductsCount, freeProductsCount: state.comboDeal.freeProductsCount, valueIsDiscount: state.comboDeal.valueIsDiscount, valueInPercentage: state.comboDeal.valueInPercentage } : null;
        let notificationTimes = [{ dayIndex: 2, hour: state.day2 }, { dayIndex: 3, hour: state.day3 }, { dayIndex: 4, hour: state.day4 }, { dayIndex: 5, hour: state.day5 }, { dayIndex: 6, hour: state.day6 }, { dayIndex: 7, hour: state.day7 }];
        if (state.day1 !== null) {
            notificationTimes.push({ dayIndex: 1, hour: state.day1 });
        }
        let orderTypes = [];
        if (state.orderTypeDelivery === true) {
            orderTypes.push({ id: 1, value: "Delivery" });
        }
        if (state.orderTypeCollection === true) {
            orderTypes.push({ id: 2, value: "Collection" });
        }
        if (state.orderTypeCurbside === true) {
            orderTypes.push({ id: 4, value: "Curbside" });
        }
        if (state.orderTypeInStore === true) {
            orderTypes.push({ id: 5, value: "In Store" });
        }

        const data = {
            id: -1,
            name: state.name,
            description: state.description,
            notificationMethod: state.notificationType,
            notificationFrequency: {
                initialPeriod: state.initialNotificationDays,
                repeatPeriod: state.repeatNotificationDays,
                notificationMethodType: state.notificationFrequency
            },
            coolDownPeriod: state.coolDownPeriod,
            promoCodeValidity: state.promoCodeValidity,
            discountType: state.discountType,
            priceDiscount: priceDiscount,
            freeProduct: freeProduct,
            comboDeal: comboDeal,
            filters: state.filters,
            emailTemplate:((state.notificationType === 'EMAIL') && state.emailTemplate && state.emailTemplate.sections.length > 0) ? {
                sections: state.emailTemplate.sections,
                backgroundColor: state.emailTemplate.backgroundColor,
                backgroundImage: state.emailTemplate.backgroundImage,

            }: null,
            notificationTimes: notificationTimes,
            orderTypes: orderTypes,

            coverageType: "ALL_MENU",
            menuDtos: [],
            categoryDtos: [],
            productDtos: [],
            imagePath: null,
            freeDelivery: false,
            activeMarketingAutomation: state.active,
            marketingAutomationPromotion: true
        }

        const url = `${SERVER_URL}/restaurant/${restaurantId}/promotion`;

        dispatch({ type: LOADING, payload: true });

        axios().post(url, data)
            .then(response => saveMarketingAutomationSuccess(dispatch, callback))
            .catch(err => saveMarketingAutomationFail(dispatch, err))
    }
};

const saveMarketingAutomationSuccess = (dispatch, callback) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:marketingAutomationsActions.saveMarketingAutomationSuccess'))
    if (callback) {
        callback();
    }
};

const saveMarketingAutomationFail = (dispatch, err) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:marketingAutomationsActions.saveMarketingAutomationFail'))
}

export const editMarketingAutomation = (selectedTrigger, state, callback) => {
    return (dispatch, getState) => {

        let orderTypes = [];
        if (state.orderTypeDelivery === true) {
            orderTypes.push({ id: 1, value: "Delivery" });
        }
        if (state.orderTypeCollection === true) {
            orderTypes.push({ id: 2, value: "Collection" });
        }
        if (state.orderTypeCurbside === true) {
            orderTypes.push({ id: 4, value: "Curbside" });
        }
        if (state.orderTypeInStore === true) {
            orderTypes.push({ id: 5, value: "In Store" });
        }

        const data = {
            ...selectedTrigger,
            activeMarketingAutomation: state.active,
            name: state.name,
            description: state.description,
            orderTypes: orderTypes,
            notificationMethod: state.notificationType,
            notificationFrequency: {
                ...selectedTrigger.notificationFrequency,
                repeatPeriod: state.repeatNotificationDays,
                initialPeriod: state.initialNotificationDays,
            },
            coolDownPeriod: state.coolDownPeriod,
            promoCodeValidity: state.promoCodeValidity,
            emailTemplate:((state.notificationType === 'EMAIL') && state.emailTemplate && state.emailTemplate.sections.length > 0) ? {
                sections: state.emailTemplate.sections,
                backgroundColor: state.emailTemplate.backgroundColor,
                backgroundImage: state.emailTemplate.backgroundImage,
                id: null
            }: null,
            // state.notificationType === 'EMAIL' ? {...state.emailTemplate, id: null}: null
        }

        const url = `${SERVER_URL}/promotion/${selectedTrigger.id}`;

        dispatch({ type: LOADING, payload: true });

        axios().put(url, data)
            .then(response => editMarketingAutomationSuccess(dispatch, callback))
            .catch(err => editMarketingAutomationFail(dispatch, err))
    }
};

const editMarketingAutomationSuccess = (dispatch, callback) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:marketingAutomationsActions.editMarketingAutomationSuccess'))
    if (callback) {
        callback();
    }
};

const editMarketingAutomationFail = (dispatch, err) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:marketingAutomationsActions.editMarketingAutomationFail'))
}



// WEBPACK FOOTER //
// ./src/actions/restaurants/marketingAutomation/MarketingAutomationAction.js